import { adminBlacklistRoutes } from '~/router/routes/car/admin/blacklist'
import { adminCategoriesRoutes } from '~/router/routes/car/admin/categories'
import { adminPopularityRoutes } from '~/router/routes/car/admin/popularity'
import { adminSearchRoutes } from '~/router/routes/car/admin/search'
import { adminSearchLogsRoutes } from '~/router/routes/car/admin/logs'
import { adminMissingMakeModelsRoutes } from './missing-makemodels'
import adminSearchEmailsRoutes from '~/router/routes/car/admin/emails'
import { adminUserTransferClassifiedsRoute } from '~/router/routes/car/admin/transfer-classifieds'
import { adminAdvertisingRoutes } from '~/router/routes/car/admin/advertising'
import { interopDefault } from '~/router/utils'
import { adminWorkStatsRoute } from '~/router/routes/car/admin/work-stats'

export default [
  ...adminBlacklistRoutes,
  ...adminCategoriesRoutes,
  ...adminAdvertisingRoutes,
  ...adminPopularityRoutes,
  ...adminSearchRoutes,
  ...adminSearchLogsRoutes,
  ...adminMissingMakeModelsRoutes,
  ...adminSearchEmailsRoutes,
  ...adminUserTransferClassifiedsRoute,
  ...adminWorkStatsRoute,
  {
    name: '__car_admin_users_edit',
    path: '/admin/users/:userId/',
    redirect: { name: '__car_admin_users_edit_user_info' },
    component: () =>
      interopDefault(
        import(
          '~/pages/car/admin/users/edit-panel.vue' /* webpackChunkName: "pages-car-admin-user-edit" */
        )
      ),
    children: [
      {
        name: '__car_admin_users_edit_user_info',
        path: 'edit',
        component: () =>
          interopDefault(
            import(
              '~/pages/car/admin/users/info/user-info.vue' /* webpackChunkName: "pages-car-admin-users-info" */
            )
          )
      },
      {
        name: '__car_admin_users_edit_user_invoices',
        path: 'invoices',
        component: () =>
          interopDefault(
            import(
              '~/pages/car/admin/users/invoices/user-invoices.vue' /* webpackChunkName: "pages-car-admin-users-invoices" */
            )
          )
      },
      {
        name: '__car_admin_users_edit_user_shop',
        path: 'shop',
        component: () =>
          interopDefault(
            import(
              '~/pages/car/admin/users/shop/user-shop.vue' /* webpackChunkName: "pages-car-admin-users-shop" */
            )
          )
      },
      {
        name: '__car_admin_users_edit_user_logs',
        path: 'logs',
        component: () =>
          interopDefault(
            import(
              '~/pages/car/admin/users/logs/user-logs.vue' /* webpackChunkName: "pages-car-admin-users-logs" */
            )
          )
      },
      {
        name: '__car_admin_users_edit_user_classifieds',
        path: 'classifieds',
        component: () =>
          interopDefault(
            import(
              '~/pages/car/admin/users/classifieds/user-classifieds.vue' /* webpackChunkName: "pages-car-admin-users-classifieds" */
            )
          )
      },
      {
        name: '__car_admin_users_edit_user_last_logs',
        path: 'last-logs',
        component: () =>
          interopDefault(
            import(
              '~/pages/car/admin/users/logs/last-logs.vue' /* webpackChunkName: "pages-car-admin-users-last-logs" */
            )
          )
      }
    ]
  }
]
